import {
  Stack,
  Typography
} from '@mui/material';

import React, { useState } from 'react';

import * as ds from './dataService';
import { useParams } from 'react-router-dom';
import { useAccessState } from 'modules/common';
import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveInstallationPlanModal } from 'modules/components/layer17';
import { InstallationItem } from 'modules/components/layer19';


export type InstallationAdditionalInfoCardProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationAdditionalInfoCardProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.installationId ?? '');
  const [fnRemovePlan] = ds.useRemoveInstallationPlan();
  const access = useAccessState('Plan');
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  const handleRemove = async (id: string) => {
    await fnRemovePlan({
      id
    });
  };



  return (
    <>{
      isVisible && (
        <SaveInstallationPlanModal.FC
          id={params.installationId ?? ''}
          isVisible
          handleClose={() => setIsVisible(() => false)}
        />
      )
    }
    <ActivityDetailSectionCardBaseLayout.FC
      title='Plans'
      subTitle={`${data.name ?? ''} Installation Plan`}
      actionButton={{
        onClick: () => {
          setIsVisible(() => true);
        },
        text: data.id ? 'Add Plan Version' : 'Select Plan',
        disabled: !access.create
      }}
      isEmpty={data && data.id === ''}
      editActionButton={{
        onClick: () => {
          setIsVisible(() => true);
        },
        text: data.id ? 'Edit Plan' : 'Add Plan',
        disabled: !access.update
      }}
    >

      <InstallationItem.FC
        id={params.installationId ?? ''}
        disableEdit={!access.update}
        title={`Version created on ${data.createdDate.toFormat('DDDD')}`}
        installationItemType='PLAN'
        disableRemove={!access.delete}
        handleRemove={async () => {
          await handleRemove(params.installationId ?? '');
        }}
      >
        <Stack
          direction='row'
        >
          <Stack>
            <Typography
              variant='formLabel'
            >
              Created On
            </Typography>

            <Typography
              variant='formInput'
            >
              {data.createdDate.toFormat('DDDD')}
            </Typography>

          </Stack>
        </Stack>

      </InstallationItem.FC>


    </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
